// Starter entries — edit freely. Leave `live` / `source` empty until real URLs exist.
export const FILTERS = ["All", "Web", "Discord Bots"];

export const PROJECTS = [
  {
    slug: "prolexbot",
    number: "01",
    title: "ProLexBot",
    category: "Discord Development",
    filters: ["Discord Bots"],
    cover: "/images/prolex-logo.jpg",
    coverClass: "object-contain p-10 bg-[#03040a]",
    tags: ["Discord Bot", "Web Dashboard", "Automation"],
    summary: "An all-in-one Discord bot for moderation, automation, and engagement — managed from its own web dashboard.",
    overview: "ProLexBot brings server management into one bot: advanced moderation, auto responses, leveling, giveaways, welcome messages, reaction roles and detailed logs — all configurable from a clean web dashboard without touching code.",
    problem: "Growing servers usually stack several bots to cover moderation, engagement and logging, which makes setup fragile and permissions hard to control. The objective: one stable, secure bot that covers every core system.",
    approach: "Separate systems for moderation, automation and engagement, all controlled from a web dashboard. Every command can be enabled or disabled, aliased, and restricted to specific roles and channels.",
    features: ["Advanced moderation — auto-mod, warnings, mutes and bans", "Auto responses and custom commands", "Leveling system with XP and role rewards", "Giveaways with requirements and multiple winners", "Welcome system with messages, images and auto-roles", "Reaction roles", "Analytics and logs", "Per-command permissions and aliases", "Web dashboard for configuration"],
    stack: ["Discord Bot", "Web Dashboard", "Automation"],
    gallery: ["/images/prolex-site.jpg", "/images/prolex-dashboard.jpg", "/images/prolex-logo.jpg"],
    challenges: "Keeping many systems stable inside one bot, and making a powerful permission model simple enough to configure from a dashboard.",
    links: { live: "https://prolex.cloud-cart.org/", source: "" },
  },
  {
    slug: "rakeezah",
    number: "02",
    title: "Rakeezah",
    category: "Education Platform",
    filters: ["Web"],
    cover: "/images/rakeezah-cover.jpg",
    tags: ["E-Learning", "Web Platform", "Arabic / RTL"],
    summary: "Rakeezah — a Saudi educational platform for General Aptitude (Qudurat), Tahsili and high-school curriculum courses.",
    overview: "Rakeezah (ركيزة) is an Arabic-first learning platform offering recorded courses, PDF notes, interactive exams and a large question bank aligned with the Saudi curriculum and Qiyas tests.",
    problem: "Students preparing for Qudurat and Tahsili need structured lessons, realistic practice and downloadable materials in one place. The objective: a simple, engaging platform that lets students learn at their own pace.",
    approach: "A right-to-left Arabic interface built around courses, lessons and exams, with a clear learning path, flexible study and interactive practice.",
    features: ["Organized video lessons per grade and subject", "Interactive exams with timer and instant grading", "Large question bank by lesson and difficulty", "Qudurat foundation — quantitative & verbal", "Downloadable PDF notes", "Light & dark mode"],
    stack: ["E-Learning", "Web Platform", "Arabic / RTL"],
    gallery: ["/images/rakeezah-cover.jpg", "/images/rakeezah.jpg", "/images/rakeezah-exams.jpg"],
    challenges: "Designing a fully right-to-left experience that stays clear and motivating for students across phones and desktops.",
    links: { live: "https://rakeezah.store/", source: "" },
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug);
